import { ModelUrlState } from "../../state/ModelUrlState";
import "../../styles/classification/generalModelAlert.css";
import {
  getTemplateTypeDisplayValue,
  TemplateType,
} from "../../types/TemplateType";

export { GeneralModelAlert };

type Props = {
  batchClassIdentifier: string;
  classifiedModelName: string;
  templateType: "GENERAL" | "FORMAT";
};

const GeneralModelAlert = ({
  batchClassIdentifier,
  classifiedModelName,
  templateType,
}: Props) => {
  const crudModelHref = ModelUrlState.calculateUrlFragments({
    batchClassIdentifier,
    name: classifiedModelName,
  });
  return (
    <span className={"generalModelBox"}>
      {`This Document Was Originally Classified As The ${getTemplateTypeDisplayValue(templateType)} Template:`}
      {/* <strong>{` ${props.classifiedModelName}`}</strong> */}
      <a
        target={"_blank"}
        href={`template-management.html${crudModelHref}`}
        rel="noreferrer"
      >
        {classifiedModelName}
      </a>
    </span>
  );
};
